import { render, staticRenderFns } from "./bank-details.vue?vue&type=template&id=183cba46&"
import script from "./bank-details.vue?vue&type=script&lang=js&"
export * from "./bank-details.vue?vue&type=script&lang=js&"
import style0 from "./bank-details.vue?vue&type=style&index=0&id=183cba46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports